import { useContext } from "react";

import MuiAvatar from "@mui/material/Avatar";

import { colors, HomeWorkOutlineIcon } from "@dotnet/telematics-design-system";

import AuthContext from "context/auth/authContext";
import { svgFontSize } from "shared";

import { AvatarProps } from "../types";

const Avatar = ({ filteredValues }: AvatarProps) => {
    const { blue700, blue100 } = colors;

    const { isSupportUser } = useContext(AuthContext);

    const renderContent = () => {
        if (!isSupportUser) {
            const companiesCount = filteredValues.length;

            switch (companiesCount) {
                case 0: {
                    return <HomeWorkOutlineIcon />;
                }
                case 1: {
                    const companyName = filteredValues[0].name.trim();
                    return companyName.charAt(0).toUpperCase();
                }
                default: {
                    return companiesCount;
                }
            }
        }

        return <HomeWorkOutlineIcon />;
    };

    return (
        <MuiAvatar
            sx={{
                color: blue700,
                background: blue100,
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "20px",
                letterSpacing: "0.1px",
                width: "24px",
                height: "24px",

                "& > svg": {
                    ...svgFontSize(16)
                }
            }}
        >
            {renderContent()}
        </MuiAvatar>
    );
};

export default Avatar;
